import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import { getGoogleSearch, getLoading } from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import { map } from 'rxjs/operators'
import {
  getDataCollectByGoogleSearch,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-google-search-count',
    templateUrl: './aggregated-amounts-google-search-count.component.html',
    styleUrls: ['./aggregated-amounts-google-search-count.component.scss'],
    standalone: false
})
export class AggregatedAmountsGoogleSearchCountComponent implements OnInit {
  googleSearchCount$: Observable<CountableSummary>
  keywords$: Observable<string>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.googleSearchCount$ = this.store.select(getGoogleSearch)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.keywords$ = this.selectedArtist$.pipe(map(it => it.googleSearch.keywords.toString()))
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByGoogleSearch)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
